export default (function () {
  var tempScrollTop,
      currentScrollTop = $(window).scrollTop();
  $(window).scroll(function () {
    if ($(window).innerWidth() >= 768) {
      currentScrollTop = $(window).scrollTop();

      if (currentScrollTop > $('header').height()) {
        $('body').addClass('fixed-header');

        if (tempScrollTop > currentScrollTop) {
          $('header').addClass('show');
        } else {
          $('header').removeClass('show');
        }
      } else {
        $('body').removeClass('fixed-header');
        $('header').removeClass('show');
      }

      tempScrollTop = currentScrollTop;
    }
  });
});